// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#home-screen .home-loading {
  margin: auto;
  display: block;
  height: 12rem;
  border-radius: 1.25rem;
  max-width: 1598px;
  width: 100%;
}
#home-screen .clock {
  display: flex;
  flex-direction: row;
  align-items: center;
  color: white;
}
@media (max-width: 767px) {
  #home-screen .clock {
    padding-top: 1.75rem;
  }
}
#home-screen .clock span {
  color: white;
  font-size: 1.6rem;
  font-weight: 300;
}
#home-screen .clock .anticon {
  margin-right: 0.5rem;
  font-size: 1.5rem;
}
#home-screen .clock .ant-statistic-content-value {
  line-height: 2rem;
}
#home-screen .subheader-button-section {
  display: flex;
  align-items: center;
}
#home-screen .subheader-button-section .gyramais-btn {
  margin-top: 0;
}
@media (max-width: 767px) {
  #home-screen .subheader-button-section .gyramais-btn {
    max-width: 100%;
    width: 100%;
  }
}
@media (max-width: 767px) {
  #home-screen .subheader-button-section {
    flex-wrap: wrap;
    justify-content: center;
  }
}
#home-screen .subheader-button-section .button-promo {
  align-self: center;
  box-shadow: 0 0 0 0 #03738c;
  transform: scale(1);
  animation: pulse 2s infinite;
  margin-right: 1rem;
}
@media (max-width: 767px) {
  #home-screen .subheader-button-section .button-promo {
    margin: 0px;
    margin-bottom: 8px;
  }
}
#home-screen .double-buttons {
  display: flex;
}
#home-screen .double-buttons button {
  margin: 0 0.75rem 0 0;
}
@media screen and (max-width: 767px) {
  #home-screen .double-buttons {
    flex-direction: column;
    align-items: center;
  }
  #home-screen .double-buttons button {
    margin: 0.75rem 0 0 0;
  }
}
#home-screen .main-content {
  margin: auto;
}
`, "",{"version":3,"sources":["webpack://./src/screens/HomeScreen/styles.less"],"names":[],"mappings":"AAAA;EAEI,YAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,WAAA;AAAJ;AAPA;EAWI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;AADJ;AAGI;EAAA;IACE,oBAAA;EAAJ;AACF;AAlBA;EAqBM,YAAA;EACA,iBAAA;EACA,gBAAA;AAAN;AAvBA;EA2BM,oBAAA;EACA,iBAAA;AADN;AA3BA;EAgCM,iBAAA;AAFN;AA9BA;EAqCI,aAAA;EACA,mBAAA;AAJJ;AAlCA;EAyCM,aAAA;AAJN;AAMM;EAAA;IACE,eAAA;IACA,WAAA;EAHN;AACF;AAMI;EAAA;IACE,eAAA;IACA,uBAAA;EAHJ;AACF;AAjDA;EAuDM,kBAAA;EAEA,2BAAA;EACA,mBAAA;EACA,4BAAA;EACA,kBAAA;AAJN;AAMM;EAAA;IACE,WAAA;IACA,kBAAA;EAHN;AACF;AA9DA;EAqEI,aAAA;AAJJ;AAjEA;EAuEM,qBAAA;AAHN;AAKI;EAAA;IACE,sBAAA;IACA,mBAAA;EAFJ;EAAE;IAII,qBAAA;EADN;AACF;AA7EA;EAkFI,YAAA;AAFJ","sourcesContent":["#home-screen {\n  .home-loading {\n    margin: auto;\n    display: block;\n    height: 12rem;\n    border-radius: @border-radius;\n    max-width: @content-max-width;\n    width: 100%;\n  }\n\n  .clock {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    color: white;\n\n    @media (max-width: 767px) {\n      padding-top: 1.75rem;\n    }\n\n    span {\n      color: white;\n      font-size: 1.6rem;\n      font-weight: 300;\n    }\n\n    .anticon {\n      margin-right: 0.5rem;\n      font-size: 1.5rem;\n    }\n\n    .ant-statistic-content-value {\n      line-height: 2rem;\n    }\n  }\n\n  .subheader-button-section {\n    display: flex;\n    align-items: center;\n\n    .gyramais-btn {\n      margin-top: 0;\n\n      @media (max-width: 767px) {\n        max-width: 100%;\n        width: 100%;\n      }\n    }\n\n    @media (max-width: 767px) {\n      flex-wrap: wrap;\n      justify-content: center;\n    }\n\n    .button-promo {\n      align-self: center;\n\n      box-shadow: 0 0 0 0 rgba(3, 115, 140, 1);\n      transform: scale(1);\n      animation: pulse 2s infinite;\n      margin-right: 1rem;\n\n      @media (max-width: 767px) {\n        margin: 0px;\n        margin-bottom: 8px;\n      }\n    }\n  }\n  .double-buttons {\n    display: flex;\n    button {\n      margin: 0 0.75rem 0 0;\n    }\n    @media screen and (max-width: 767px) {\n      flex-direction: column;\n      align-items: center;\n      button {\n        margin: 0.75rem 0 0 0;\n      }\n    }\n  }\n  .main-content {\n    margin: auto;\n  }\n}\n\n@xs-screen: 480px;@sm-screen: 576px;@md-screen: 768px;@lg-screen: 992px;@xl-screen: 1200px;@xxl-screen: 1600px;@content-max-width: 1598px;@border-radius: 1.25rem;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
